import { render } from "./NavigationSidebar.vue?vue&type=template&id=68e54c04&scoped=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js"

import "./NavigationSidebar.vue?vue&type=style&index=0&id=68e54c04&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e54c04"]])

export default __exports__